import StarStarredIcon from '@atlaskit/icon/core/star-starred';
import StarUnstarredIcon from '@atlaskit/icon/core/star-unstarred';
import type { NewCoreIconProps } from '@atlaskit/icon/types';

import type { FormOptionValue } from '../../types/form/form-fields/field-values';

export const RATING_ICONS = ['star'] as const;
export type RatingIcon = (typeof RATING_ICONS)[number];

type IconComponent = {
	(props: NewCoreIconProps): JSX.Element;
	displayName: string;
};

const isValidRatingIcon = (value: string): value is RatingIcon =>
	RATING_ICONS.includes(value as RatingIcon);

/**
 * Derives the rating icon name from the first option's label text.
 * The label of the first option stores the icon identifier (e.g. 'star').
 * Falls back to 'star' if no valid icon is found.
 */
export const getRatingIconFromOptions = (options?: FormOptionValue[]): RatingIcon => {
	const firstLabel = options?.[0]?.label?.toLowerCase() ?? '';
	return isValidRatingIcon(firstLabel) ? firstLabel : 'star';
};

const unselectedIconMapping: Record<RatingIcon, IconComponent> = {
	star: StarUnstarredIcon,
};

const selectedIconMapping: Record<RatingIcon, IconComponent> = {
	star: StarStarredIcon,
};

export const getRatingIconComponent = (ratingIcon: RatingIcon): IconComponent =>
	unselectedIconMapping[ratingIcon] ?? StarUnstarredIcon;

export const getSelectedRatingIconComponent = (ratingIcon: RatingIcon): IconComponent =>
	selectedIconMapping[ratingIcon] ?? StarStarredIcon;
